import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    taskId: String,
    hasChildren: Boolean,
    updateUrl: String,
    confirmMessage: String,
    confirmYes: String,
    confirmNo: String
  }

  static targets = ["checkbox"]

  async onChange(event) {
    const checkbox = event.target
    const showInCalendar = checkbox.checked

    if (this.taskIdValue && this.hasChildrenValue) {
      const applyToChildren = confirm(this.confirmMessageValue)
      await this.updateVisibility(showInCalendar, applyToChildren)
    }
  }

  async updateVisibility(showInCalendar, applyToChildren) {
    if (!this.updateUrlValue) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (!csrfToken) return

    try {
      const response = await fetch(this.updateUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({
          task_id: this.taskIdValue,
          show_in_calendar: showInCalendar,
          apply_to_children: applyToChildren
        })
      })

      if (!response.ok) {
        console.error("Failed to update calendar visibility")
        if (this.hasCheckboxTarget) {
          this.checkboxTarget.checked = !showInCalendar
        }
      }
    } catch (error) {
      console.error("Error updating calendar visibility:", error)
      if (this.hasCheckboxTarget) {
        this.checkboxTarget.checked = !showInCalendar
      }
    }
  }
}
